<template>
  <div id="app">
    <div class="step-holder mx-auto step-0" v-show="step == 0">
      <onboarding-step-00 />
    </div>
    <div class="step-holder mx-auto step-100" v-show="step == 100">
      <onboarding-step-01
        v-bind:onboardingMachineBrancheDefault="
          onboardingData.opportunities_branche
        "
      />
    </div>
    <div class="step-holder mx-auto step-200" v-show="step == 200">
      <onboarding-step-02
        v-bind:onboardingMachineBrancheDefault="
          onboardingData.opportunities_branche
        "
        v-bind:onboardingMachineCategoryDefault="
          onboardingData.opportunities_area
        "
        v-bind:onboardingManufacturerDefault="
          onboardingData.opportunities_producer
        "
        v-bind:onboardingMachineTypeDefault="onboardingData.opportunities_type"
      />
    </div>
    <div class="step-holder mx-auto step-300" v-show="step == 300">
      <onboarding-step-03
        v-bind:onboardingMachineBrancheDefault="
          onboardingData.opportunities_branche
        "
        v-bind:onboardingMachineCategoryDefault="
          onboardingData.opportunities_area
        "
        v-bind:onboardingManufacturerDefault="
          onboardingData.opportunities_producer
        "
        v-bind:onboardingMachineTypeDefault="onboardingData.opportunities_type"
        v-bind:onboardingMachineYearDefault="onboardingData.opportunities_year"
        v-bind:onboardingMachineNettoPrice="
          onboardingData.opportunities_nettoprice
        "
      />
    </div>
    <div class="step-holder mx-auto step-400" v-show="step == 400">
      <onboarding-step-04
        v-bind:onboardingMachineBrancheDefault="
          onboardingData.opportunities_branche
        "
        v-bind:onboardingMachineCategoryDefault="
          onboardingData.opportunities_area
        "
        v-bind:onboardingManufacturerDefault="
          onboardingData.opportunities_producer
        "
        v-bind:onboardingMachineTypeDefault="onboardingData.opportunities_type"
        v-bind:onboardingMachineYearDefault="onboardingData.opportunities_year"
        v-bind:onboardingMachineNettoPrice="
          onboardingData.opportunities_nettoprice
        "
        v-bind:onboardingCustomerEmail="
          onboardingData.customer_contact_emailadress
        "
      />
    </div>
    <div class="step-holder mx-auto step-500" v-show="step == 500">
      <onboarding-step-05
        v-bind:onboardingMachineBrancheDefault="
          onboardingData.opportunities_branche
        "
        v-bind:onboardingMachineCategoryDefault="
          onboardingData.opportunities_area
        "
        v-bind:onboardingManufacturerDefault="
          onboardingData.opportunities_producer
        "
        v-bind:onboardingMachineTypeDefault="onboardingData.opportunities_type"
        v-bind:onboardingMachineYearDefault="onboardingData.opportunities_year"
        v-bind:onboardingMachineNettoPrice="
          onboardingData.opportunities_nettoprice
        "
        v-bind:onboardingCustomerEmail="
          onboardingData.customer_contact_emailadress
        "
      />
    </div>
    <div class="step-holder mx-auto step-1001" v-show="step == 1001">
      <appointment-step-01 :appointment="appointment" />
    </div>
    <div class="step-holder mx-auto step-1002" v-show="step == 1002">
      <appointment-step-02
        :appointment="appointment"
        :onBoardingAppointmentDateDefault="
          appointmentData.customer_appointment_date
        "
        :onBoardingAppointmentTimeDefault="
          appointmentData.customer_appointment_time
        "
      />
    </div>
  </div>
</template>

<script>
import OnboardingStep00 from "./OnboardingStep00.vue";
import OnboardingStep01 from "./OnboardingStep01.vue";
import OnboardingStep02 from "./OnboardingStep02.vue";
import OnboardingStep03 from "./OnboardingStep03.vue";
import OnboardingStep04 from "./OnboardingStep04.vue";
import OnboardingStep05 from "./OnboardingStep05.vue";
import AppointmentStep01 from "./AppointmentStep01.vue";
import AppointmentStep02 from "./AppointmentStep02.vue";

import { EventBus } from "@/event-bus";
import axios from "axios";

export default {
  name: "app",
  props: ["source", "counterpart"],
  data() {
    return {
      debug: false,
      step: 0, // INFO: Set this to a diffent number to see further steps, e.g. 100 or 200.
      validate: false,
      onboardingData: {
        opportunities_branche: "",
        opportunities_area: "",
        opportunities_producer: "",
        opportunities_type: "",
        opportunities_year: "",
        opportunities_nettoprice: "",
        customers_company: "",
        customers_name: "",
        customer_contact_emailadress: "",
        customers_password: "",
        customer_contact_phonenumber: "",
        tracking_approved: "false",
        login_email: "",
        login_password: "",
        userLogin: false,
      },
      appointmentData: {
        customer_appointment_date: "",
        customer_appointment_time: "",
        customer_appointment_name: "",
        customer_appointment_email: "",
        customer_appointment_phonenumber: "",
        customer_appointment_dsgvo: "",
        tracking_approved: "false",
      },
      appointment: false,
      apiResponse: {},
    };
  },
  mounted() {
    let that = this
    //console.log('APP MOUNTED')
    //console.log(this.$route)
    //console.log('THE APPTSATE INITIAL')
    //console.log(this.$route.params.appstate)
    if(this.$route.params.appstate !== undefined){
      this.redirectUser(this.$route.params.appstate)
    }

       // if back button is pressed
   window.onpopstate = function() {
    if(that.step == 100){
      that.reprint(0)
    }
    if(that.step == 200){
      that.reprint(100)
    }
    if(that.step == 300){
      that.reprint(200)
    }
    if(that.step == 400){
      that.reprint(300)
    }
    if(that.step == 500){
      that.reprint(400)
    }
    if(that.step == 1001){
      that.reprint(0)
    }
    if(that.step == 1002){
      that.reprint(1001)
    }
   };
  },
  created: function() {
    //console.log('APP IS CREATED')
    let uri = window.location.href.split("?");
    if (uri.length == 2) {
      let vars = uri[1].split("&");
      let getVars = {};
      let tmp = "";
      vars.forEach(function(v) {
        tmp = v.split("=");
        if (tmp.length == 2) getVars[tmp[0]] = tmp[1];
      });
      this.log("App.vue: Get-Parameters BEGINN");
      //console.log(getVars);
      this.log("App.vue: Get-Parameters END");

      if(getVars.appointment == "true"){
        console.log("App received appointment_request");
        this.log("App.vue: Event received: appointment_request");
        this.scrollToTop();
        this.reprint(1001);
        this.appointment = true;
        window.ga_trackPageView("/onboarding/appointments/dateselection");
        window.ga_trackEvent("AppointmentButtonClicked", "Anfrage stellen");
      }
    }
    // Steps (event-handling done!)
    EventBus.$on("submit_step_0", (payload) => {
      this.log("App.vue: Event received: submit_step_0");
      this.onboardingData.opportunities_branche = payload.opportunities_branche;
      this.scrollToTop();
      this.reprint(100);
      window.ga_trackPageView("/onboarding/wizard/manufacturerselection");
      window.ga_trackEvent(
        "MachinecategorieSelection",
        this.onboardingData.opportunities_branche
      );

      this.updateUrl(payload.opportunities_branche)


    });
    EventBus.$on("submit_step_100", (payload) => {
      this.log("App.vue: Event received: submit_step_100");
      this.onboardingData.opportunities_area = payload.opportunities_area;
      this.onboardingData.opportunities_producer =
        payload.opportunities_producer;
      this.onboardingData.opportunities_type = payload.opportunities_type;
      this.scrollToTop();
      this.reprint(200);
      window.ga_trackPageView("/onboarding/wizard/manufacturerselection");
      window.ga_trackEvent(
        "MachinecategorieSelection",
        this.onboardingData.opportunities_area
      );
    });
    EventBus.$on("submit_step_200", (payload) => {
      this.log("App.vue: Event received: submit_step_200");
      this.onboardingData.opportunities_year = payload.opportunities_year;
      this.onboardingData.opportunities_nettoprice =
        payload.opportunities_nettoprice;
      this.scrollToTop();
      this.reprint(300);
      window.ga_trackPageView("/onboarding/wizard/machinetype");
      window.ga_trackEvent(
        "ManufacturerSelection",
        this.onboardingData.opportunities_producer
      );
    });

    EventBus.$on("submit_step_300", (payload) => {
      this.onboardingData.customer_contact_emailadress =
        payload.customers_email;
      this.onboardingData.customers_company = payload.customers_company;
      this.onboardingData.customers_name = payload.customers_name;
      this.onboardingData.customer_contact_phonenumber =
        payload.customer_contact_phonenumber;
      this.onboardingData.customers_dsgvo = payload.customers_dsgvo;
      this.onboardingData.customers_password = payload.customers_password;
      this.log("App.vue: Event received: submit_step_300");
      this.onboardingData.userLogin = false;
      window.ga_trackPageView("/onboarding/wizard/send");
      window.ga_trackEvent("WizardGetCalculation", "Anfrage stellen");
      this.makeOpportunityRequest();
    });

    EventBus.$on("submit_step_300_login", (payload) => {
      this.onboardingData.login_email = payload.login_email;
      this.onboardingData.login_password = payload.login_password;
      this.onboardingData.userLogin = true;
      this.log("App.vue: Event received: submit_step_300_login");

      window.ga_trackPageView("/onboarding/wizard/send");
      window.ga_trackEvent("WizardGetCalculation", "Anfrage stellen");
      this.makeOpportunityRequest();

    });

    EventBus.$on("appointment_request", () => {
      // Keine payload!
      let that = this
      console.log("App received appointment_request");
      this.log("App.vue: Event received: appointment_request");
      this.scrollToTop();
      this.appointment = true;
      window.ga_trackPageView("/onboarding/appointments/dateselection");
      window.ga_trackEvent("AppointmentButtonClicked", "Anfrage stellen");


      setTimeout(() => {
        console.log('in tiomeout loop')
        that.updateUrl('Termin')
        that.reprint(1001);
      }, 100)

    });
    EventBus.$on("submit_step_app100", (payload) => {
      console.log(payload);
      var chosenDate = payload.date;
      this.appointmentData.customer_appointment_time = payload.time;
      this.appointmentData.customer_appointment_name =
        payload.app_customers_name;
      this.appointmentData.customer_appointment_email =
        payload.app_customers_email;
      this.appointmentData.customer_appointment_phonenumber =
        payload.app_customers_contact_phonenumber;
      this.appointmentData.customer_appointment_dsgvo =
        payload.app_customers_dsgvo;

      var dd = chosenDate.getDate();
      var mm = chosenDate.getMonth() + 1;
      var yyyy = chosenDate.getFullYear();
      if (dd < 10) {
        dd = "0" + dd;
      }
      if (mm < 10) {
        mm = "0" + mm;
      }
      var fancyDate = dd + "." + mm + "." + yyyy;
      this.appointmentData.customer_appointment_date = fancyDate;
      this.log("App.vue: Event received: submit_step_app100");
      window.ga_trackEvent(
        "AppointmentDate",
        this.appointmentData.customer_appointment_date
      );
      this.scrollToTop();
      this.makeAppointmentRequest();
      window.ga_trackPageView("/onboarding/appointments/send");
    });
    EventBus.$on("start_onboarding", () => {
      // Kein payload!
      this.log("App.vue: Event received: start_onboarding");
      this.scrollToTop();
      this.reprint(0);
    });
    EventBus.$on("dataRefresh", () => {
      // Kein payload!
      this.log("App.vue: Event received: dataRefresh");
    });
    EventBus.$on("requestHash", (payload) => {
      this.requestAndGo(payload);
      this.log("App.vue: Event received: requestHash");
    });
    EventBus.$on("changeStep", (payload) => {
      console.log("App received changeStep");
      this.log("App.vue: Event received: changeStep");
      this.scrollToTop();
      this.reprint(payload.step_number);

      if(payload.step_number == 0){
        this.updateUrl('/')
      }
    });
    EventBus.$on("appointment_cancel", () => {
      // Keine payload!
      console.log("App received appointment_cancel");
      this.log("App.vue: Event received: appointment_cancel");
      this.scrollToTop();
      this.reprint(0);
      this.appointment = false;

      this.updateUrl('/')

    });

    EventBus.$on("evaluateNewMachine", () => {
        this.onboardingData.opportunities_branche= "";
        this.onboardingData.opportunities_area= "";
        this.onboardingData.opportunities_producer= "";
        this.onboardingData.opportunities_type= "";
        this.onboardingData.opportunities_year= "";
        this.onboardingData.opportunities_nettoprice= "";
        this.onboardingData.customers_company= "";
        this.onboardingData.customers_name= "";
        this.onboardingData.customer_contact_emailadress= "";
        this.onboardingData.customers_password= "";
        this.onboardingData.customer_contact_phonenumber= "";
        this.onboardingData.tracking_approved= "false";
        this.onboardingData.login_email= "";
        this.onboardingData.login_password= "";
        this.onboardingData.userLogin= false;
        this.apiResponse= {};
        this.reprint(0);
    });


    this.log(
      "Vue has been created...Source: " +
        this.source +
        " Counterpart:" +
        this.counterpart
    );
  },
  components: {
    "onboarding-step-00": OnboardingStep00,
    "onboarding-step-01": OnboardingStep01,
    "onboarding-step-02": OnboardingStep02,
    "onboarding-step-03": OnboardingStep03,
    "onboarding-step-04": OnboardingStep04,
    "onboarding-step-05": OnboardingStep05,
    "appointment-step-01": AppointmentStep01,
    "appointment-step-02": AppointmentStep02,
  },
  methods: {
    reprint: function(newstep) {
      if (newstep == undefined || (newstep == "" && newstep != 0)) {
        this.log("ERROR: App.vue: reprint() called with undefined newstep!");
      } else {
        EventBus.$emit("dataRefresh", {
          onboardingData: this.onboardingData,
        });

        this.log("App.vue: reprint().called()");
        this.log("App.vue: reprint() Old-Step: " + this.step);
        this.step = newstep;
        this.log("App.vue: reprint() New-Step: " + newstep);
      }

      this.log("BOC Collected Data:");
      this.log(this.onboardingData);
      this.log("EOC Collected Data:");
    },
    log: function(obj) {
      if (this.debug) {
        console.log(obj);
      }
    },
    requestAndGo: function(payload){
      let createURL =
        "https://enquiry.leaseback.private.color-und-code.de/onboarding/enquiry/requestHash";

      if (window.location.host == "onboarding.leaseback.de") {
        createURL = "https://enquiry.leaseback.de/onboarding/enquiry/requestHash";
      }

      let currentObj2 = this;
      let redirectURL = "https://enquiry.leaseback.private.color-und-code.de/onboarding/result/"

      axios
        .post(createURL, payload)
        .then(function(response) {
          currentObj2.apiResponse = response.data;
          currentObj2.log("Then Function of AJAX-Called... called()");
          currentObj2.log(currentObj2.apiResponse);
          window.location.href = redirectURL + response.data.hashvalue + '/';

        })
        .catch(function(error) {
          currentObj2.log("catch Function of AJAX-Called... error()");
          currentObj2.log(error);
          currentObj2.apiResponse = error;
        });
    },
    makeOpportunityRequest() {
      let createURL =
        "https://enquiry.leaseback.private.color-und-code.de/onboarding/enquiry/send";

      if (window.location.host == "onboarding.leaseback.de") {
        createURL = "https://enquiry.leaseback.de/onboarding/enquiry/send";
      }

      if (window.ga_tracking_Enabled) {
        this.onboardingData.tracking_approved = "true";
      }
      let currentObj = this;
      
      axios
        .post(createURL, {
          onboardingData: this.onboardingData,
        })
        .then(function(response) {
          currentObj.apiResponse = response.data;
          currentObj.log("Then Function of AJAX-Called... called()");
          currentObj.log(currentObj.apiResponse);
          
          if (currentObj.apiResponse.requestBlocked) {
            currentObj.scrollToTop();
            currentObj.reprint(500);
            window.ga_trackPageView("/onboarding/wizard/finish/nooffer");
          } else {
              // if users log in
            if(currentObj.apiResponse.userLogin){
              // if logged in successfully
              if(currentObj.apiResponse.loginSuccess == 1){
                EventBus.$emit("requestHash", {
                  requestID: currentObj.apiResponse.requestID,
                });
              }else{ // if log in has bad credentials
                EventBus.$emit("wrongCredentialsBackend", {
                  message: currentObj.apiResponse.errorMessage,
                });
              }
            }else{
              currentObj.scrollToTop();
              currentObj.reprint(400);
              window.ga_trackPageView("/onboarding/wizard/finish/okay");
             
              setTimeout(function () {
                window.ga_trackTransaction(
                  currentObj.apiResponse.requestID,
                  currentObj.onboardingData.opportunities_producer +  " " + currentObj.onboardingData.opportunities_type,
                  currentObj.onboardingData.opportunities_area,
                  currentObj.apiResponse.requestValue
                );
                
              },1000);
              
            }
          }
        })
        .catch(function(error) {
          currentObj.log("catch Function of AJAX-Called... error()");
          currentObj.log(error);
          currentObj.apiResponse = error;
        });
    },
    makeAppointmentRequest() {
      //SEND TO URL
      let createURL =
        "https://enquiry.leaseback.private.color-und-code.de/onboarding/appointment/send";
      if (window.location.host == "onboarding.leaseback.de") {
        createURL = "https://enquiry.leaseback.de/onboarding/appointment/send";
      }
      if (window.ga_tracking_Enabled) {
        this.appointmentData.tracking_approved = "true";
      }
      let currentObj = this;
      axios
        .post(createURL, {
          appointmentData: this.appointmentData,
        })
        .then(function(response) {
          currentObj.apiResponse = response.data;
          currentObj.log("Then Function of AJAX-Called... called()");
          currentObj.log(currentObj.apiResponse);
          if (currentObj.apiResponse.requestBlocked) {
            currentObj.reprint(0); // Nicht so fein.
          } else {
            currentObj.reprint(1002); // Alles ist fein.
          }
        })
        .catch(function(error) {
          currentObj.log("catch Function of AJAX-Called... error()");
          currentObj.log(error);
          currentObj.apiResponse = error;
        });
    },
    scrollToTop() {
      window.scrollTo(0, 0);
    },
    updateUrl(url) {
      // reset url to prevent false urls 
      history.pushState({}, null, '/');
      const { href } = this.$router.resolve(url); 
      //console.log('params:')
      //console.log(this.$route.params)
      history.pushState({}, null, href);
      //console.log(url)
      this.$route.params.appstate = url

    },
    redirectUser(path){
      if(path == 'Metall'){
        //console.log('redirect to Metall')
        EventBus.$emit("submit_step_0", {
          opportunities_branche: "Metall",
        });
      }
      else if(path == 'Holz'){
        //console.log('redirect to Holz')
        EventBus.$emit("submit_step_0", {
          opportunities_branche: "Holz",
        });
      }
      else if(path == 'Druck'){
        //console.log('redirect to Druck')
        EventBus.$emit("submit_step_0", {
          opportunities_branche: "Druck",
        });
      }
      else if(path == 'Kunststoff'){
        //console.log('redirect to Kunststoff')
        EventBus.$emit("submit_step_0", {
          opportunities_branche: "Kunststoff",
        });
      }
      else if(path == 'Bau'){
        //console.log('redirect to Bau')
        EventBus.$emit("submit_step_0", {
          opportunities_branche: "Bau",
        });
      }
      else if(path == 'Andere'){
        //console.log('redirect to Andere')
        EventBus.$emit("submit_step_0", {
          opportunities_branche: "Andere",
        });
      }
      else if(path == 'Termin'){
        //console.log('redirect to Termin')
        EventBus.$emit("appointment_request");
      }
      else{
        //console.log('no valid url, route to /')
        this.updateUrl('/')
      }
    }
  },

  watch: {
    flightcountselection_trigger: function() {
      this.log("App.vue: flightcountselection_trigger.changed();");
    },
  },
};
</script>
<style>

.pointer {
  cursor: pointer;
}
.step-background-color {
  background-color: #F3F3F3;
}

input[type="tel" i] {
  font-size: 20px;
}

@media (min-width: 768px) {
  .step-holder {
    max-width: 800px;
  }
}
@media (min-width: 1061px) {
  .step-holder {
    max-width: 1000px;
  }
}
@media (min-width: 1320px) {
  .step-holder {
    max-width: 1280px;
  }
}
</style>
